module.exports = __webpack_public_path__ + "static/media/M122ws.ac3e154c.pdf";